export const pt_text: Record<string, string> = {
  "Sign in to your Lulu Loyal account to access all our features.":
    "Entre na sua conta Lulu Loyal para acessar todos os nossos recursos.",
  "Don't have an account?": "Não tem uma conta?",
  "Click here to create one.": "Clique aqui para criar uma.",
  "Create Lulu Loyal Account": "Criar Conta Lulu Loyal",
  "Log In To Lulu Loyal": "Entrar no Lulu Loyal",
  "Forgot Password?": "Esqueceu a senha?",
  "Delete Account": "Excluir Conta",
  "Confirm Delete": "Confirmar Exclusão",
  "Are you sure you want to delete your account? This action cannot be undone and will cancel any active subscriptions.":
    "Tem certeza de que deseja excluir sua conta? Esta ação não pode ser desfeita e cancelará qualquer assinatura ativa.",
  "Delete Permanently": "Excluir Permanentemente",
  "Confirm Logout": "Confirmar Saída",
  "Are you sure you want to logout?": "Tem certeza de que deseja sair?",
  "Password Recovery": "Recuperação de Senha",
  "Enter your email address to receive a login link.":
    "Digite seu endereço de e-mail para receber um link de login.",
  "Send Recovery Email": "Enviar E-mail de Recuperação",
  "Recovery email sent. Please check your inbox.":
    "E-mail de recuperação enviado. Por favor, verifique sua caixa de entrada.",
  "Account updated successfully.": "Conta atualizada com sucesso.",
  "How Lulu Works": "Como o Lulu Funciona",
  "100% untraceable": "100% inrastreável",
  "Just share the username": "Apenas compartilhe o nome de usuário",
  "No Login Required": "Sem necessidade de login",
  "Invalid login link": "Link de login inválido",
  "Signing you in...": "Fazendo login...",
  Loading: "Carregando",
  "Analyzing {username}": "Analisando {username}",
  seconds: "segundos",
  "Figuring out who they follow": "Descobrindo quem eles seguem",
  "Looking at who follows them": "Vendo quem os segue",
  "Figuring out who's new": "Descobrindo quem é novo",
  "Looking for suspicious profiles": "Procurando perfis suspeitos",
  "Taking a closer look": "Olhando mais de perto",
  "Looking through off-site content": "Analisando conteúdo externo",
  "Analyzing behavior patterns": "Analisando padrões de comportamento",
  "Checking for red flags": "Verificando sinais de alerta",
  "Wrapping up (this can take a while)":
    "Finalizando (isso pode demorar um pouco)",
  "Finding stories": "Encontrando stories",
  "Loading story content": "Carregando conteúdo de stories",
  "Processing media": "Processando mídia",
  "Preparing anonymous view": "Preparando visualização anônima",
  Finalizing: "Finalizando",
  "Email Address": "Endereço de email",
  Save: "Salvar",
  "@username": "@usuário",
  "Reveal Follows": "Revelar seguidos",
  "Anonymously View Stories": "Ver stories anonimamente",
  "find red flags": "encontrar sinais de alerta",
  "Best Results": "Melhores resultados",
  "Search over a billion accounts": "Pesquisar mais de um bilhão de contas",
  "Is this legal?": "Isso é legal?",
  "Lulu Loyal": "Lulu Loyal",
  LINKS: "LINKS",
  "Why Use Lulu Loyal?": "Por que usar o Lulu Loyal?",
  Prices: "Preços",
  Resources: "Recursos",
  LEGAL: "LEGAL",
  "Privacy Policy": "Política de privacidade",
  "Terms of Use": "Termos de uso",
  "Refund Policy": "Política de reembolso",
  "CONTACT US": "ENTRE EM CONTATO",
  "support@lululoyal.com": "support@lululoyal.com",
  "© 2025 Lulu Loyal. All Rights Reserved.":
    "© 2025 Lulu Loyal. Todos os direitos reservados.",
  "Manage Account": "Gerenciar conta",
  Login: "Login",
  Anonymity: "Anonimato",
  "Secure + Untraceable": "Seguro + Inrastreável",
  "Security Risks": "Riscos de segurança",
  Pricing: "Preços",
  "Lowest Prices": "Preços mais baixos",
  "Pretends to Be Free": "Finge ser grátis",
  Speed: "Velocidade",
  "Fastest + Best Results": "Mais rápido + Melhores resultados",
  "Slow + Poor Results": "Lento + Resultados ruins",
  Quality: "Qualidade",
  "Unmatched Accuracy": "Precisão incomparável",
  "Consistent Errors": "Erros consistentes",
  Features: "Recursos",
  "Best Features": "Melhores recursos",
  "Limited Features": "Recursos limitados",
  "Insta/TikTok/Snap": "Insta/TikTok/Snap",
  "All 3": "Todos os 3",
  "Only Instagram": "Apenas Instagram",
  "Everyone Else": "Todos os outros",
  "🌶️ Porn account": "🌶️ Conta pornô",
  "🍒 Baddie": "🍒 Gata",
  "🍑 Spicy content": "🍑 Conteúdo picante",
  "No Red Flags": "Sem sinais de alerta",
  "Follows back": "Segue de volta",
  "No follow back": "Não segue de volta",
  "Subscribe to reveal all": "Assine para revelar tudo",
  "{number} new girls": "{number} garotas novas",
  "{number} new guys": "{number} garotos novos",
  "{number} Others": "{number} outros",
  "Subscribe to Reveal All": "Assine para revelar tudo",
  "{number} RED FLAGS": "{number} SINAIS DE ALERTA",
  "{number} SUS PROFILES": "{number} PERFIS SUSPEITOS",
  "Updated {hours}h ago": "Atualizado há {hours}h",
  "This account is private": "Esta conta é privada",
  "Notify Me": "Me notifique",
  "Reveal More": "Revelar mais",
  "UPDATED {hours} HOURS AGO": "ATUALIZADO HÁ {hours} HORAS",
  "Stories from @{username}": "Stories de @{username}",
  "Refresh Stories": "Atualizar stories",
  "{number} STORIES": "{number} STORIES",
  "ANONYMOUS VIEWING": "VISUALIZAÇÃO ANÔNIMA",
  "Subscribe to view": "Assine para visualizar",
  "User Not Found": "Usuário não encontrado",
  "Try Again": "Tentar novamente",
  "Results for": "Seguidos mais recentes de:",
  "+{number} more": "+{number} mais",
  "View All Recent Followers": "Ver todos os seguidores recentes",
  "See Who They Followed": "Ver quem eles seguiram",
  "Recent Follows": "Seguindo Recentemente",
  "Recent Followers": "Seguidores Recentes",
  "Thank You!": "Obrigado!",
  "Your subscription is now active.": "Sua assinatura está agora ativa.",
  "You now have full access to all Lulu Loyal features.":
    "Agora você tem acesso completo a todos os recursos do Lulu Loyal.",
  "Start Analyzing": "Começar Análise",
  "Create a Lulu Loyal account to access all our features.":
    "Crie uma conta Lulu Loyal para acessar todos os nossos recursos.",
  "If you have an account, ": "Se você tem uma conta, ",
  "you can login by clicking here.": "você pode fazer login clicando aqui.",
  "My Account": "Minha Conta",
  "Change Email Address": "Alterar Endereço de Email",
  "Change Password": "Alterar Senha",
  "Manage Subscription": "Gerenciar Assinatura",
  "You are already subscribed": "Você já está inscrito",
  "Account not found": "Conta não encontrada",
  "View All": "Ver Tudo",
  Girls: "Garotas",
  Guys: "Rapazes",
  Other: "Outro",
  All: "Todos",
  "Lulu Loyal's FAQ": "FAQ do Lulu Loyal",
  "PER WEEK": "POR SEMANA",
  "Stop guessing, learn the truth, and reduce your anxiety levels with Lulu Loyal's tools.":
    "Pare de adivinhar, descubra a verdade e reduza seus níveis de ansiedade com as ferramentas do Lulu Loyal.",
  "Unlimited access to all tools.": "Acesso ilimitado a todas as ferramentas.",
  "No commitment, cancel any time.":
    "Sem compromisso, cancele a qualquer momento.",
  "Free relationship anxiety guide.":
    "Guia gratuito de ansiedade no relacionamento.",
  "Get Unlimited Access": "Obter Acesso Ilimitado",
  "User Reviews": "Avaliações de Usuários",
  "Step 1 - Enter a Username": "Passo 1 - Digite um nome de usuário",
  "Enter a username to start the search.":
    "Digite um nome de usuário para iniciar a pesquisa.",
  "Step 2 - Anonymous Search": "Passo 2 - Pesquisa Anônima",
  "Do an untraceable, anonymous search.":
    "Faça uma pesquisa anônima e inrastreável.",
  "Step 3 - Best Results": "Passo 3 - Melhores Resultados",
  "Receive the best results, learn the truth.":
    "Receba os melhores resultados, descubra a verdade.",
  "Instantly saw who my boyfriend had just followed! Got rid of soo much anxiety!":
    "Vi instantaneamente quem meu namorado acabou de seguir! Me livrei de tanta ansiedade!",
  "- Sophie": "- Sophie",
  "My ex was following Onlyfan models... like 4 of them 😭😭😭 At least I left him in time 🥲":
    "Meu ex estava seguindo modelos do OnlyFans... tipo 4 delas 😭😭😭 Pelo menos eu o deixei a tempo 🥲",
  "- Osheb": "- Osheb",
  "I noticed my SO was following a bunch of new accounts very day... turns out it was nothing, good to check.":
    "Notei que meu parceiro estava seguindo muitas contas novas todos os dias... acabou que não era nada, foi bom verificar.",
  "- Anonymous": "- Anônimo",
  "Most recent follow": "Seguido mais recente",
  "Loyalty analysis": "Análise de lealdade",
  "Can I trust these results?": "Posso confiar nesses resultados?",
  "Yes, our tech is best in class, and it's designed to be as accurate as possible. If you can't get the results you're looking for here, you can't get them anywhere. Our tech is the most advanced.":
    "Sim, nossa tecnologia é a melhor da categoria e foi projetada para ser o mais precisa possível. Se você não conseguir os resultados que procura aqui, não os conseguirá em lugar nenhum. Nossa tecnologia é a mais avançada.",
  "Is this 100% anonymous?": "Isso é 100% anônimo?",
  "Yes, there's no way anyone could ever know, or see that you've searched for a person. They'll also never know you've searched for them either. We've made that our top priority.":
    "Sim, não há como alguém saber ou ver que você pesquisou por uma pessoa. Eles também nunca saberão que você os pesquisou. Fizemos disso nossa prioridade máxima.",
  "Can I catch cheaters with this?": "Posso pegar traidores com isso?",
  "Yes, many people have, and many people have stopped themselves landing in heartbreak. You can use Lulu Loyal to make sure you're not interacting with people who will mess you around.":
    "Sim, muitas pessoas fizeram isso, e muitas pessoas evitaram ter o coração partido. Você pode usar o Lulu Loyal para garantir que não está interagindo com pessoas que vão te magoar.",
  "All the data we gather is public and it's 100% legal to collect this data, and to interact with this data too. You're not doing anything which breaks any law anywhere by searching for someone.":
    "Todos os dados que coletamos são públicos e é 100% legal coletar esses dados e interagir com eles também. Você não está fazendo nada que viole qualquer lei em qualquer lugar ao pesquisar alguém.",
  "Why should I trust Lulu Loyal?": "Por que devo confiar no Lulu Loyal?",
  "Because we've been in your shoes, which is exactly why we built this product. What matters most to us, is to help other people find good people that won't mess them around.":
    "Porque já estivemos no seu lugar, e é exatamente por isso que criamos este produto. O que mais importa para nós é ajudar outras pessoas a encontrar boas pessoas que não as magoem.",
  "Unlimited Searches": "Pesquisas Ilimitadas",
  "Completely Anonymous": "Completamente Anônimo",
  "No Commitment. Cancel Anytime.":
    "Sem Compromisso. Cancele a Qualquer Momento.",
  "Easy to Cancel": "Fácil de Cancelar",
  "Secured by Stripe Payments": "Protegido por Stripe Payments",
};
